export const SETTING_GROUPS = [
  {
    key: 'org',
    title: 'Organization & Access',
    icon: 'bi-building-gear',
    color: '#3b82f6',
    items: [
      { title: 'Users Management', path: '/settings/users', icon: 'bi-person-gear', roles: ['admin', 'manager'] },
      { title: 'Teams Management', path: '/settings/teams', icon: 'bi-people', roles: ['admin', 'manager'] },
      { title: 'Roles Management', path: '/settings/roles', icon: 'bi-shield-lock', roles: ['admin'] },
      { title: 'Permissions Matrix', path: '/settings/permissions', icon: 'bi-grid-3x3-gap', roles: ['admin'] },
    ],
  },
  {
    key: 'sales',
    title: 'Sales Pipeline',
    icon: 'bi-graph-up-arrow',
    color: '#10b981',
    items: [
      { title: 'Stage Management', path: '/settings/stages', icon: 'bi-kanban', roles: ['admin'] },
      { title: 'Automation Workflows', path: '/settings/workflows', icon: 'bi-diagram-3', roles: ['admin', 'manager'] },
      { title: 'Sales Targets', path: '/settings/sales-targets', icon: 'bi-bullseye', roles: ['admin', 'manager'] },
      { title: 'Lose Reasons', path: '/settings/lose-reasons', icon: 'bi-x-circle', roles: ['admin'] },
      { title: 'Visit Topics', path: '/settings/visit-topics', icon: 'bi-journal-check', roles: ['admin'] },
    ],
  },
  {
    key: 'support',
    title: 'Customer Support',
    icon: 'bi-headset',
    color: '#8b5cf6',
    items: [
      { title: 'General Settings', path: '/settings/ticket-general', icon: 'bi-shield-check', roles: ['admin'] },
      { title: 'Ticket Topics', path: '/settings/ticket-topics', icon: 'bi-chat-square-text', roles: ['admin', 'manager'] },
      { title: 'Ticket Systems', path: '/settings/ticket-systems', icon: 'bi-pc-display', roles: ['admin', 'manager'] },
      { title: 'Ticket Status', path: '/settings/ticket-Status', icon: 'bi-ui-radios-grid', roles: ['admin', 'manager'] },
      { title: 'Ticket Feedback', path: '/settings/ticket-feedback', icon: 'bi-star-half', roles: ['admin'] },
    ],
  },
  {
    key: 'omni',
    title: 'Chat Hub & Inbox',
    icon: 'bi-chat-dots',
    color: '#06b6d4',
    items: [
      { title: 'Social Accounts', path: '/settings/omni-accounts', icon: 'bi-chat-dots', roles: ['admin'] },
      { title: 'Provider Apps', path: '/settings/omni-provider-apps', icon: 'bi-plug', roles: ['admin'] },
      { title: 'AI Knowledge Base', path: '/settings/omni-knowledge', icon: 'bi-database-fill-check', roles: ['admin'] },
      { title: 'Test AI', path: '/settings/test-ai', icon: 'bi-robot', roles: ['admin'] },
    ],
  },
  {
    key: 'assets',
    title: 'IT Asset Management',
    icon: 'bi-pc-display-horizontal',
    color: '#f59e0b',
    items: [
      { title: 'General Settings', path: '/settings/assets', icon: 'bi-gear-fill', roles: ['admin'] },
      { title: 'Asset Brands', path: '/settings/asset-brands', icon: 'bi-tag-fill', roles: ['admin', 'manager'] },
      { title: 'Asset Categories', path: '/settings/asset-categories', icon: 'bi-grid-fill', roles: ['admin', 'manager'] },
    ],
  },
  {
    key: 'bizdata',
    title: 'Business Data',
    icon: 'bi-database',
    color: '#ec4899',
    items: [
      { title: 'Company Settings', path: '/settings/company', icon: 'bi-building', roles: ['admin'] },
      { title: 'Product Management', path: '/settings/products', icon: 'bi-box-seam', roles: ['admin', 'manager'] },
      { title: 'Contact Positions', path: '/settings/contact-positions', icon: 'bi-person-badge', roles: ['admin'] },
      { title: 'Customer Tags', path: '/settings/customer-tags', icon: 'bi-tags', roles: ['admin'] },
      { title: 'Opportunity Tags', path: '/settings/opportunity-tags', icon: 'bi-tags-fill', roles: ['admin'] },
      { title: 'Custom Fields', path: '/settings/custom-fields', icon: 'bi-ui-checks', roles: ['admin'] },
      { title: 'Provinces (จังหวัด)', path: '/settings/provinces', icon: 'bi-geo-alt', roles: ['admin', 'manager'] },
    ],
  },
  {
    key: 'member',
    title: 'Member & Loyalty',
    icon: 'bi-person-heart',
    color: '#e11d48',
    items: [
      { title: 'General Settings', path: '/settings/member/general', icon: 'bi-gear', roles: ['admin'] },
      { title: 'PDPA & Privacy', path: '/settings/member/pdpa', icon: 'bi-shield-check', roles: ['admin'] },
      { title: 'Authentication', path: '/settings/member/auth', icon: 'bi-shield-lock', roles: ['admin'] },
      { title: 'SMS & OTP Logs', path: '/settings/member/sms-logs', icon: 'bi-chat-left-dots', roles: ['admin', 'manager'] },
      { title: 'Tier Management', path: '/settings/member/tiers', icon: 'bi-award', roles: ['admin'] },
      { title: 'Points Rules', path: '/settings/member/points-rules', icon: 'bi-lightning', roles: ['admin', 'manager'] },
      { title: 'POS & ERP Integrations', path: '/settings/member/api-integrations', icon: 'bi-box-arrow-in-down', roles: ['admin'] },
      { title: 'Member Data Destinations (Outbound)', path: '/settings/member/outbound-sync', icon: 'bi-box-arrow-up-right', roles: ['admin'] },
      { title: 'Import Transactions (Excel)', path: '/settings/member/import-excel', icon: 'bi-file-earmark-spreadsheet', roles: ['admin', 'manager'] },
      { title: 'Member Migration Tool', path: '/settings/member-migration', icon: 'bi-person-plus-fill', roles: ['admin'] },
    ],
  },
  {
    key: 'sysadmin',
    title: 'System Administration',
    icon: 'bi-terminal',
    color: '#6b7280',
    items: [
      { title: 'API Keys', path: '/settings/api-keys', icon: 'bi-key', roles: ['admin'] },
      { title: 'License', path: '/settings/license', icon: 'bi-patch-check', roles: ['admin', 'manager'] },
      { title: 'Menu Structure', path: '/settings/menus', icon: 'bi-list-ul', roles: ['admin'] },
      { title: 'Email Config (System)', path: '/settings/email-config', icon: 'bi-envelope-at', roles: ['admin'] },
      { title: 'Email Config (Marketing)', path: '/settings/marketing-email', icon: 'bi-envelope-paper-heart', roles: ['admin'] },
      { title: 'File Management', path: '/settings/file-management', icon: 'bi-folder', roles: ['admin'], badge: 'BETA' },
      { title: 'ERP Sync', path: '/settings/external-import/data-integration', icon: 'bi-arrow-repeat', roles: ['admin'] },
      { title: 'Activity Logs', path: '/settings/activity-logs', icon: 'bi-clock-history', roles: ['admin'] },
      { title: 'Email Queue', path: '/settings/email-queue', icon: 'bi-envelope-paper', roles: ['admin'] },
      { title: 'Exchange Calendar', path: '/settings/calendar-sync-logs', icon: 'bi-calendar-check', roles: ['admin'] },
      { title: 'AI Global Config', path: '/settings/ai-config', icon: 'bi-cpu-fill', roles: ['admin'] },
      { title: 'Social Config', path: '/settings/omi-channels', icon: 'bi-chat-quote', roles: ['admin'] },
      { title: 'Changelog', path: '/settings/changelog', icon: 'bi-clock-history', roles: ['admin'] },
    ],
  },
];

if (process.env.REACT_APP_ENABLE_NND === 'true') {
  SETTING_GROUPS.splice(7, 0, {
    key: 'nnd',
    title: 'NND Configuration',
    icon: 'bi-clipboard-data',
    color: '#0ea5e9',
    items: [
      { title: 'Power Map (Roles & Rel)', path: '/settings/nnd/power-map', icon: 'bi-people-fill', roles: ['admin'] },
      { title: 'MSO Types (ประเภท MSO)', path: '/settings/nnd/mso-types', icon: 'bi-layers', roles: ['admin'] },
      { title: 'MSO Groups (กลุ่ม MSO)', path: '/settings/nnd/mso-groups', icon: 'bi-diagram-3', roles: ['admin'] },
      { title: 'Segments & Levels', path: '/settings/nnd/segments', icon: 'bi-bar-chart-steps', roles: ['admin'] },
      { title: 'Insurers', path: '/settings/nnd/insurers', icon: 'bi-shield-check', roles: ['admin'] },
      { title: 'Paint Systems', path: '/settings/nnd/paint-systems', icon: 'bi-droplet-half', roles: ['admin'] },
      { title: 'Paint Brands', path: '/settings/nnd/paint-brands', icon: 'bi-palette', roles: ['admin'] },
      { title: 'Product Types (ชั้นสี)', path: '/settings/nnd/product-types', icon: 'bi-layers-half', roles: ['admin'] },
      { title: 'Pain Points', path: '/settings/nnd/pain-points', icon: 'bi-exclamation-triangle', roles: ['admin'] },
      { title: 'VAS Items', path: '/settings/nnd/vas-items', icon: 'bi-star', roles: ['admin'] },
    ]
  });
}
